import { ca } from '@cian/analytics';

export const trackRealtyCalendarBannerShow = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'realty_calendar',
    action: 'show',
    label: 'banner',
  });
};

export const trackRealtyCalendarBannerClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'realty_calendar',
    action: 'click',
    label: 'banner',
  });
};
